import React, { useCallback, useEffect, useState } from "react";
import {
  Button,
  Col,
  Container,
  Dropdown,
  Form,
  Nav,
  NavDropdown,
  Navbar,
  Row,
} from "react-bootstrap";

// css
import styles from "./Header.module.scss";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import UploadStockPopup from "../Modals/UploadStock/uploadStockPopup";

// img
import red_cross from "../../Assets/svg/red-cross.svg";
import user from "../../Assets/images/user.png";
import logo from "../../Assets/images/logo.png";
import { useDispatch, useSelector } from "react-redux";
import { get, post, updateToken } from "../../helpers/api_helper";
import { logout } from "../../store/login";
import toast from "react-hot-toast";
import { updateProfile } from "../../store/login";

const Header = ({ sidebar, setSidebar }) => {
  const token = useSelector((state) => state.login.token);
  const [userData, setUserData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const fetchUser = useCallback(async () => {
    setLoading(true);
    try {
      const response = await get(`/user/admin/profile`);

      if (response?.success) {
        setUserData(response?.data || []);
        dispatch(
          updateProfile({
            userData: response?.data,
          })
        );
      } else {
        console.log("Failed to fetch users");
        setUserData([]);
      }
    } catch (error) {
      console.log("An error occurred while fetching users", error);
    } finally {
      setLoading(false);
    }
  }, []);
  const handleLogout = () => {
    dispatch(logout());
    navigate("/login");
  };

  useEffect(() => {
    if (token) {
      updateToken(token);
      fetchUser();
    }
  }, [token, fetchUser]);
  const [stockData, setStockData] = useState("");

  const handleStockData = () => setStockData(!stockData);
  const handleSidebar = () => setSidebar(!sidebar);

  const closeDropdown = () => setIsDropdownOpen(false);

  const location = useLocation();

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append("file", file);

      try {
        const response = await post("/user/upload", formData);
        if (response?.success) {
          fetchUser();
          toast.success("Image uploaded successfully!");
        }
      } catch (error) {
        console.error("Error uploading image:", error);
      }
    }
  };
  return (
    <>
      <UploadStockPopup stockData={stockData} setStockData={setStockData} />

      <header className={`${styles.siteHeader} siteHeader sticky-top py-2`}>
        <Navbar expand="lg" className="bg-body-tertiary">
          <Container fluid>
            <div className="left d-flex align-items-center gap-10">
              <Button
                onClick={handleSidebar}
                className="border-0 p-0 me-2 d-lg-none"
                variant="transparent"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M4 18H20C20.55 18 21 17.55 21 17C21 16.45 20.55 16 20 16H4C3.45 16 3 16.45 3 17C3 17.55 3.45 18 4 18ZM4 13H20C20.55 13 21 12.55 21 12C21 11.45 20.55 11 20 11H4C3.45 11 3 11.45 3 12C3 12.55 3.45 13 4 13ZM3 7C3 7.55 3.45 8 4 8H20C20.55 8 21 7.55 21 7C21 6.45 20.55 6 20 6H4C3.45 6 3 6.45 3 7Z"
                    fill="black"
                  />
                </svg>
              </Button>
            </div>
            <Navbar.Brand href="/" className={`${styles.logo} d-lg-none`}>
              <img src={logo} alt="" className="img-fluid" />
            </Navbar.Brand>
            <h4 className="m-0 fw-sbold themeClr text-capitalize me-2 d-lg-block d-none">
              {location.pathname.replace(/^\/+/, "").replace(/-/g, " ")}
            </h4>
            <Navbar.Toggle
              className={`border-0 p-0`}
              aria-controls="navbarScroll"
            />
            <Navbar.Collapse id="navbarScroll">
              {/* <Nav className="me-auto my-2 my-lg-0">
                <NavLink
                  onClick={handleStockData}
                  // to=""
                  className={`${styles.navLink} ${styles.btn} navLink fw-sbold  d-inline-flex align-items-center justify-content-center  position-relative bg-transparent themeClr `}
                >
                  <span className={`${styles.icndot} icndot position-absolute`}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="6"
                      height="6"
                      viewBox="0 0 6 6"
                      fill="none"
                    >
                      <circle
                        cx="3"
                        cy="3"
                        r="3"
                        fill="url(#paint0_linear_38_1223)"
                      />
                      <defs>
                        <linearGradient
                          id="paint0_linear_38_1223"
                          x1="3"
                          y1="0"
                          x2="3"
                          y2="6"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#3A674A" />
                          <stop offset="1" stopColor="#0C3D1D" />
                        </linearGradient>
                      </defs>
                    </svg>
                  </span>
                  Import Data
                </NavLink>
              </Nav> */}
              <Form className="d-flex align-items-center gap-10">
                <Dropdown
                  className={`${styles.myProfileBtn} myProfileBtn`}
                  show={isDropdownOpen}
                  onToggle={() => setIsDropdownOpen(!isDropdownOpen)}
                >
                  <Dropdown.Toggle
                    variant="transparent"
                    className={`${styles.dropdownToggle} d-flex text-start border-0 p-0 align-items-center `}
                    id="dropdown-basic"
                  >
                    <div
                      className={`${styles.imgWrp} imgWrp me-2 p-1 rounded-circle`}
                      style={{ background: "#E6EBF2" }}
                    >
                      <img
                        src={
                          userData?.profileImage ? userData?.profileImage : user
                        }
                        alt=""
                        className="img-fluid rounded-circle"
                      />
                    </div>
                    <div className={`${styles.content} content`}>
                      <h6 className="m-0 fw-sbold">{userData?.name}</h6>
                      <p className="m-0">{userData?.email}</p>
                    </div>
                  </Dropdown.Toggle>

                  <Dropdown.Menu
                    className={`${styles.drpMenu} drpMenu px-3 border-0`}
                  >
                    <Button
                      className="border-0 p-0 position-absolute"
                      style={{ top: 5, right: 5 }}
                      variant="transparent"
                      onClick={closeDropdown}
                    >
                      <img src={red_cross} alt="" />
                    </Button>
                    <div className={`${styles.top} top py-2 mb-2`}>
                      <h6 className="m-0 fw-bold">Admin Profile</h6>
                    </div>
                    <Form>
                      <Row>
                        <Col lg="12" className="my-2 text-center">
                          <div
                            className={`${styles.uploadFile} uploadFile border-0 d-inline-block position-relative mx-auto`}
                          >
                            <input
                              type="file"
                              className="file position-absolute w-100 h-100"
                              onChange={handleFileChange}
                            />
                            <img
                              src={
                                userData?.profileImage
                                  ? userData?.profileImage
                                  : user
                              }
                              alt=""
                              className="img-fluid rounded-circle"
                              width={100}
                            />
                            <span
                              className={`${styles.icn} icn position-absolute`}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="40"
                                height="40"
                                viewBox="0 0 40 40"
                                fill="none"
                              >
                                <circle cx="20" cy="20" r="20" fill="white" />
                                <path
                                  d="M27.9898 26.9537C28.5469 26.9537 29 27.4128 29 27.9771C29 28.5425 28.5469 29.0005 27.9898 29.0005H22.2797C21.7226 29.0005 21.2695 28.5425 21.2695 27.9771C21.2695 27.4128 21.7226 26.9537 22.2797 26.9537H27.9898ZM24.0299 11.6996L25.5049 12.8713C26.1098 13.3443 26.513 13.9677 26.6509 14.6235C26.8101 15.3448 26.6403 16.0532 26.1628 16.6659L17.3764 28.0284C16.9732 28.5444 16.3789 28.8346 15.7422 28.8454L12.2404 28.8884C12.0494 28.8884 11.8902 28.7594 11.8478 28.5766L11.0519 25.126C10.914 24.4917 11.0519 23.836 11.4552 23.3308L17.6842 15.2685C17.7903 15.1395 17.9813 15.119 18.1086 15.2147L20.7297 17.3002C20.8995 17.4399 21.1329 17.5152 21.377 17.4829C21.897 17.4184 22.2471 16.9454 22.1941 16.4402C22.1622 16.1822 22.0349 15.9672 21.8651 15.8059C21.8121 15.7629 19.3183 13.7635 19.3183 13.7635C19.1592 13.6345 19.1273 13.398 19.2547 13.2378L20.2416 11.9575C21.1541 10.7858 22.7459 10.6783 24.0299 11.6996Z"
                                  fill="url(#paint0_linear_0_15418)"
                                />
                                <defs>
                                  <linearGradient
                                    id="paint0_linear_0_15418"
                                    x1="20"
                                    y1="11.0005"
                                    x2="20"
                                    y2="29.0005"
                                    gradientUnits="userSpaceOnUse"
                                  >
                                    <stop stopColor="#3A674A" />
                                    <stop offset="1" stopColor="#0C3D1D" />
                                  </linearGradient>
                                </defs>
                              </svg>
                            </span>
                          </div>
                        </Col>
                        <Col lg="12" className="my-2">
                          <div
                            className={`${styles.labelInput} position-relative labelInput`}
                          >
                            <div className="text-center position-relative">
                              <h5>{userData?.name}</h5>
                              <p>{userData?.email}</p>
                            </div>
                          </div>
                        </Col>

                        <Col lg="12" className="my-3">
                          <div
                            className={`${styles.logout} logout text-center`}
                          >
                            <Button
                              onClick={handleLogout}
                              className="rounded-pill p-1 d-inline-flex align-items-center justify-content-center pe-3"
                            >
                              <span className="icn me-2">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="26"
                                  height="26"
                                  viewBox="0 0 26 26"
                                  fill="none"
                                >
                                  <circle cx="13" cy="13" r="13" fill="white" />
                                  <path
                                    d="M17.9708 7.28859L17.9708 7.28859L17.9689 7.28641C17.5675 6.83279 16.9041 6.75812 16.4355 7.09539L16.4351 7.09572C15.937 7.45316 15.768 8.11666 16.0466 8.66837L16.048 8.6711C16.1099 8.79596 16.2099 8.92301 16.3295 9.04248L16.3312 9.04426C17.7677 10.4982 18.3446 12.2735 17.8341 14.3294L17.8341 14.3295C17.3466 16.2894 16.0916 17.5916 14.2444 18.1773L14.2439 18.1775C12.4432 18.7457 10.7473 18.3827 9.29385 17.1611C8.04104 16.1106 7.39943 14.6968 7.37738 13.0317C7.35838 11.7029 7.8042 10.528 8.62331 9.5252C8.69458 9.43739 8.77424 9.36624 8.83162 9.31544C8.83664 9.31099 8.8415 9.30669 8.84621 9.30253C8.90256 9.25268 8.93761 9.22167 8.96795 9.1882L8.96793 9.18818L8.97093 9.18495C9.3007 8.82898 9.38902 8.42543 9.24507 7.95198C9.09942 7.48526 8.79129 7.22026 8.32751 7.12616C7.98891 7.05821 7.68268 7.14281 7.38088 7.38516L7.37967 7.38612C6.77746 7.8659 6.35485 8.51596 5.96088 9.25146C5.29886 10.4885 5.00042 11.824 5.04793 13.2448L5.04794 13.2453C5.10383 14.9779 5.65228 16.5167 6.68685 17.8675C7.66908 19.1469 8.89547 20.0439 10.3793 20.4968L10.3796 20.4969C12.912 21.2721 15.2522 20.8673 17.372 19.2076L17.3722 19.2075C18.7442 18.1347 19.6461 16.7092 20.094 14.9676L20.0945 14.9658C20.2628 14.3235 20.3359 13.6622 20.339 12.9821C20.3074 10.8173 19.5663 8.97535 18.1076 7.44387L18.3972 7.168L18.1084 7.4447C18.077 7.41197 18.0257 7.35224 17.9948 7.31625C17.9833 7.30291 17.9747 7.29283 17.9708 7.28859Z"
                                    fill="#EB5757"
                                    stroke="white"
                                    strokeWidth="0.8"
                                  />
                                  <path
                                    d="M11.1115 10.6564C11.1144 11.4968 11.7262 12.1935 12.5224 12.273C13.3478 12.3585 14.0855 11.8024 14.2494 10.9651C14.2728 10.8459 14.2758 10.7237 14.2758 10.6014M11.1115 10.6564C11.1056 8.39514 11.1056 7.60051 11.1115 5.33921C11.1115 4.73722 11.3837 4.26968 11.8725 3.9641C12.3819 3.64324 12.9263 3.63102 13.4474 3.93049C13.9801 4.23607 14.267 4.72194 14.2699 5.36366M11.1115 10.6564L11.5114 10.6554C11.5114 10.6554 11.5114 10.6553 11.5114 10.6553C11.5138 11.3043 11.9833 11.8172 12.5621 11.8749L12.5636 11.8751C13.1758 11.9385 13.7313 11.5298 13.8569 10.8882L13.8569 10.8879C13.8722 10.8101 13.8757 10.7218 13.8758 10.6025M11.1115 10.6564L11.5114 10.655L13.8758 10.6025M14.2699 5.36366C14.2718 6.08143 14.2713 6.50107 14.2706 7.00316C14.2703 7.28769 14.2699 7.5987 14.2699 8.00546V8.00552C14.2699 9.11473 14.2699 9.49219 14.2758 10.6014M14.2699 5.36366L13.8699 5.36548C13.8699 5.36536 13.8699 5.36524 13.8699 5.36512M14.2699 5.36366L13.8699 5.3647C13.8699 5.36484 13.8699 5.36498 13.8699 5.36512M14.2758 10.6014L13.8758 10.6035C13.8758 10.6032 13.8758 10.6028 13.8758 10.6025M14.2758 10.6014H13.8758C13.8758 10.6018 13.8758 10.6021 13.8758 10.6025M13.8758 10.6025C13.8699 9.49303 13.8699 9.11466 13.8699 8.00546C13.8699 7.59767 13.8703 7.28635 13.8706 7.00178C13.8713 6.50037 13.8718 6.08197 13.8699 5.36512M13.8758 10.6025L11.5114 5.34025L11.5115 5.33921C11.5115 4.87817 11.71 4.5374 12.0845 4.30329L12.0857 4.30255L12.0857 4.30255C12.4704 4.0602 12.8562 4.05207 13.248 4.27729L13.2483 4.27746C13.6556 4.51105 13.8675 4.86432 13.8699 5.36512"
                                    fill="#EB5757"
                                    stroke="white"
                                    strokeWidth="0.8"
                                  />
                                </svg>
                              </span>
                              Log Out
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  </Dropdown.Menu>
                </Dropdown>
              </Form>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </header>
    </>
  );
};

export default Header;
